import { proxy } from 'valtio/vanilla'
import { getSharedState } from '../valtio'

// Shared session data any consumer can read: feature flags, workspace/account
// identity + roles, and user id. Set once at app boot and never changed after,
// so it's read-only. Auth stuff and values that change at runtime stay app-only
// for now. Roles are plain `string` so this package doesn't depend on app types.

export interface SessionWorkspace {
  id: number
  role: string | null
  highestRole: string
}

export interface SessionAccount {
  id: number
  role: string
  customSearchFieldId?: string
  reasoningEnabled: boolean
}

export interface SessionUser {
  id: number
}

export interface Session {
  features: Readonly<Record<string, boolean>>
  workspace: SessionWorkspace | null
  account: SessionAccount | null
  user: SessionUser | null
}

export const emptySession: Session = {
  features: {},
  workspace: null,
  account: null,
  user: null,
}

export const sessionState = getSharedState('session', () => proxy<Session>({ ...emptySession }))
